<template>
  <BaseCardSection title="Základní údaje" :is-visible="true">
    <div class="row g-3">
      <!-- 1. Název kalkulace -->
      <div class="col-md-12">
        <label class="form-label fw-bold">Název kalkulace: <small class="text-muted">({{
            nameLength
          }}/120)</small></label>
        <input
            type="text"
            class="form-control"
            v-tooltip="'Zadejte stručný a výstižný název pro kalkulaci, název je viditelný pro zákazníka - propisuje se do předmětu nabídky / objednávky! Délka je omezena na max 120 znaků.'"
            v-model="localData.name"
            maxlength="120"
            @input="emitUpdate"
            v-validate="{
                   rules: { required: true},
                   message: { required: 'Název kalkulace je povinný'},
                   options: { showValidState: false }
                 }"/>
      </div>

      <!-- 2. Obchodní parametry -->
      <div class="col-md-3">
        <label class="form-label">Záloha (%)</label>
        <input
            type="number"
            class="form-control"
            v-model="localData.proformaValue"
            v-validate="{
                     rules: { required: true, min: 50 },
                     message: { required: 'Záloha je povinná', min: 'Minimálně 50%'},
                     options: { showValidState: false }
                   }"
            @input="emitUpdate">
      </div>

      <div class="col-md-4">
        <label class="form-label">Termín dodání:</label>
        <input
            type="text"
            class="form-control"
            v-model="localData.deliveryTime"
            @input="emitUpdate"
            v-validate="{
                     rules: { required: true },
                     message: { required: 'Termín dodání je povinný'},
                     options: { showValidState: false }
                   }">
      </div>

      <div class="col-md-3">
        <label class="form-label">Sazba DPH:</label>
        <select
            class="form-select"
            v-model="localData.vat"
            @change="emitUpdate"
            v-validate="{
                     rules: { required: true },
                     message: { required: 'Sazba DPH je povinná'},
                     options: { showValidState: false }
                   }">
          <option v-for="(text, key) in vatOptions" :key="key" :value="key">{{ text }}</option>
        </select>
      </div>

      <div class="col-md-2 d-flex align-items-end pb-2">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="delegatedVatDet"
                 v-model="localData.delegatedVat" @change="emitUpdate">
          <label class="form-check-label" for="delegatedVatDet">Přenesená daň</label>
        </div>
      </div>

      <!-- 3. Interní poznámka -->
      <div class="col-md-12">
        <label class="form-label">Interní poznámka:</label>
        <textarea class="form-control" rows="4" v-model="localData.internalNote" @input="emitUpdate"></textarea>
      </div>
    </div>
  </BaseCardSection>
</template>

<script setup>
import {reactive, computed, watch, defineProps, defineEmits} from 'vue';
import BaseCardSection from "@/components/base/BaseCardSection.vue";

const props = defineProps({
  // Místo celé kalkulace přijmeme jen "plochý" objekt se základními poli
  details: {type: Object, required: true}
});

const emit = defineEmits(['update:details']);

// reactive teď kopíruje jen pár polí, ne tisíce vnořených objektů
const localData = reactive({...props.details});

const vatOptions = {0: '0 %', 12: '12 %', 21: '21 %'};
const nameLength = computed(() => localData.name ? localData.name.length : 0);

const emitUpdate = () => {
  emit('update:details', {...localData});
};

watch(() => props.details, (newVal) => {
  Object.assign(localData, newVal);
}, {deep: true});
</script>